import { render, staticRenderFns } from "./joinList.vue?vue&type=template&id=082272aa&scoped=true"
import script from "./joinList.vue?vue&type=script&lang=js"
export * from "./joinList.vue?vue&type=script&lang=js"
import style0 from "./joinList.vue?vue&type=style&index=0&id=082272aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082272aa",
  null
  
)

export default component.exports